import {useState} from 'react';
import get from 'lodash/get';

import Dialog from '@mui/material/Dialog';
import EditIcon from '@mui/icons-material/EditCalendar';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import useUser from '../../hooks/useUser';
import SessionForm from './SessionForm';
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

const EditSessionButton = props => {
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const user = useUser();
  const isPatient = get(user, 'is_patient') || false;
  const {iconOnly, textOnly, session} = props;
  const childProps = {
    onClick: () => setDialogIsOpen(true),
    disabled: false,
    variant: iconOnly ? null : (props.variant || 'contained'),
    color: iconOnly ? 'primary' : undefined,
    startIcon: iconOnly || textOnly ? null : <EditIcon/>,
    fullWidth: props.fullWidth || null,
    size: props.size
  };
  const onClose = () => setDialogIsOpen(false);
  // Patients can no longer edit sessions
  if (isPatient) return null;
  return (
    <>
      <Dialog
        open={dialogIsOpen}
        fullWidth={true}
        maxWidth='md'
        onClose={onClose}
      >
        {
          session
          ? <SessionForm
            isPatient={isPatient}
            session={session}
            onClose={onClose}
            onSubmitted={props.onSubmitted}
          />
          : <></>
        }
      </Dialog>
      {
        iconOnly
        ? <Tooltip title='Edit Session'>
          <IconButton {...childProps}>
            <EditIcon/>
          </IconButton>
        </Tooltip>
        : <Button {...childProps}>
            Edit Session
        </Button>
      }
    </>
  );
};

export default EditSessionButton;
